export default class YoutubeEmbed {
  constructor({ data }) {
    this.data = data || { url: "" };
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement("div");

    const input = document.createElement("input");
    input.type = "text";
    input.placeholder = "https://www.youtube.com/watch?v=...";
    input.value = this.data.url;
    input.className = "w-full border p-2 rounded mb-2";

    const iframe = document.createElement("iframe");
    iframe.width = "100%";
    iframe.height = "315";
    iframe.className = "rounded";

    const updateIframe = (url) => {
      if (!url || typeof url !== "string") return;

      const match = url.match(/(?:\?v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/);
      if (match) {
        iframe.src = `https://www.youtube.com/embed/${match[1]}`;
      } else {
        iframe.src = "";
      }
    };

    input.addEventListener("input", (e) => {
      this.data.url = e.target.value;
      updateIframe(e.target.value);
    });

    updateIframe(this.data.url); // <- Initialer Aufruf

    this.wrapper.appendChild(input);
    this.wrapper.appendChild(iframe);
    return this.wrapper;
  }

  save() {
    return this.data;
  }

  static get toolbox() {
    return {
      title: "YouTube",
      icon: "▶️",
    };
  }
}
